__turbopack_context__.v({
  "column": "FundTeamCard-module-scss-module__nj7T7q__column",
  "linkIcon": "FundTeamCard-module-scss-module__nj7T7q__linkIcon",
  "section": "FundTeamCard-module-scss-module__nj7T7q__section",
  "teamCol": "FundTeamCard-module-scss-module__nj7T7q__teamCol",
  "teamInfo": "FundTeamCard-module-scss-module__nj7T7q__teamInfo",
  "teamLogo": "FundTeamCard-module-scss-module__nj7T7q__teamLogo",
  "teamName": "FundTeamCard-module-scss-module__nj7T7q__teamName",
  "teamTag": "FundTeamCard-module-scss-module__nj7T7q__teamTag",
});
